import InputErrorIcon from '@crm/shared/assets/icons/input-error.svg?react';
import { SvgIcon } from '@crm/shared/ui';

export const InformationFieldError = ({
    errorMessage,
    id,
}: {
    errorMessage: string;
    id: string;
}) => (
    <div className="absolute top-3 right-0 z-50 -translate-y-1/2 pr-2">
        <SvgIcon icon={InputErrorIcon} className="size-3.5" />
        <div
            id={id}
            className="absolute right-0 bottom-full z-50 mb-1 hidden w-max max-w-52 flex-col items-center justify-start group-focus-within/info-field:inline-flex"
        >
            <div className="flex flex-col items-start justify-start gap-2 self-stretch rounded-lg bg-red-500 px-3 py-2">
                <div className="inline-flex items-center justify-center gap-2.5 self-stretch">
                    <div className="flex-1 justify-start text-[10px] leading-3 font-normal text-primary-foreground">
                        {errorMessage}
                    </div>
                </div>
            </div>
            <div
                aria-hidden="true"
                className="absolute top-full right-2.5 h-0 w-0 border-x-[5px] border-t-[5px] border-x-transparent border-t-red-500"
            />
        </div>
    </div>
);
